import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import {
  GetUpcomingAppointment,
  changeAppointmentData,
  clearAppointmentData,
  getOnsiteAppReq,
} from "../../../StateManagement/Reducers/AppointmentsState";

import {
  Card,
  Comdisp,
  Hrline,
  AppointmentWrapper,
  AppointmentTitle,
  AppointmentSubText,
  AppointmentActions,
  AppointmentAddressRow,
} from "./styles";

import { FiCalendar } from "react-icons/fi";

import AppointmentCancel from "../../Appointment/AppointmentCancel";
import NoDataImage from "./NoDataImage";
import Loading from "../../StyledComponents/Loading";

import { PageSubTitle, Button, Text, Image } from "../../StyledComponents";

import { AiOutlineCloseCircle } from "react-icons/ai";
import { BiLocationPlus } from "react-icons/bi";
import { FiClock } from "react-icons/fi";

import NoAppt from "../../../Assets/images/no_appt_image.png";
import Rectangle from "../../../Assets/images/Rectangle.png";
import moment from "moment";
import { toast } from "react-toastify";
import Error from "../../../Modules/StyledComponents/Toastify/Error";

const Nextappt = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [apptCancel, setApptcancel] = useState(false);
  const [CancelDate, setCancelDate] = useState("");
  const [CancelData, setCancelData] = useState("");

  const NextAppointment = useSelector(
    (state) => state.Appointments.upcomingAppointment,
  );
  const Refresh = useSelector((state) => state.Appointments.RefreshAppt);
  const OnsiteAppReq = useSelector((state) => state.Appointments.OnsiteAppReq);

  const loading = useSelector((state) => state.Appointments.Loading);

  const navigatePage = () => {
    if (parseInt(OnsiteAppReq["allow_portal"]) === 1) {
      if (parseInt(OnsiteAppReq["individual_patient"]) === 0) {
        navigate("/appointment/add_appointment");
        dispatch(clearAppointmentData(""));
      } else if (
        parseInt(OnsiteAppReq["individual_patient"]) === 1 &&
        parseInt(OnsiteAppReq["newpat_allow"]) === 1
      ) {
        navigate("/appointment/add_appointment");
        dispatch(clearAppointmentData(""));
      } else {
        toast(<Error msg="You're not allow to Make an Appointment" />, {
          containerId: "B",
          className: "error_badge",
        });
      }
    } else {
      toast(<Error msg="You're not allow to Make an Appointment......" />, {
        containerId: "B",
        className: "error_badge",
      });
    }
  };

  const upcomingFiltered = useMemo(() => {
    if (!NextAppointment || NextAppointment.length === 0) return [];

    const now = moment();

    return NextAppointment.filter((appt) => {
      if (!appt.ApptFromDate && !appt.eventDateTime) return false;

      const apptDateTime = appt.eventDateTime
        ? moment(appt.eventDateTime)
        : moment(appt.ApptFromDate);

      return apptDateTime.isSameOrAfter(now);
    })
      .sort((a, b) => {
        const aDate = a.eventDateTime
          ? moment(a.eventDateTime)
          : moment(a.ApptFromDate);

        const bDate = b.eventDateTime
          ? moment(b.eventDateTime)
          : moment(b.ApptFromDate);

        return aDate.diff(bDate);
      })
      .slice(0, 2);
  }, [NextAppointment]);

  useEffect(() => {
    dispatch(GetUpcomingAppointment("show"));
  }, []);

  useEffect(() => {
    if (Refresh) {
      dispatch(GetUpcomingAppointment("show"));
    }
  }, [Refresh]);

  useEffect(() => {
    dispatch(getOnsiteAppReq());
  }, []);

  return (
    <>
      <Card
        gridArea="Appointment"
        background="#ffffff"
        border="1px solid #d8e0f0"
        borderradius="8px"
        padding="20px"
        margintop="6px"
        width="100%"
      >
        <Comdisp disp="flex" alignItem="center" JustifyContent="space-between">
          <PageSubTitle fontweight="600" lineHeight="33px" media>
            Upcoming Appointment
          </PageSubTitle>

          <Button
            border="1px solid #407BFF"
            background="#F4F8FF"
            color="#407BFF"
            borderRadius="6px"
            padding="6px 14px"
            fontSize="13px"
            fontWeight="500"
            lineHeight="18px"
            onClick={() => navigatePage()}
          >
            Schedule Appointment
          </Button>
        </Comdisp>
        <Hrline mt="10px" mb="6px" />
        {loading ? (
          <Loading />
        ) : upcomingFiltered.length !== 0 ? (
          <>
            {upcomingFiltered.map((details, index) => (
              <AppointmentWrapper key={details.pc_eid}>
                <Comdisp disp="flex" alignItem="center" marginBottom="6px">
                  <FiCalendar className="clock" />
                  <AppointmentTitle>
                    {moment(details.ApptFromDate).format("dddd DD MMM YYYY")} @{" "}
                    {details.duration}
                  </AppointmentTitle>
                </Comdisp>

                <Comdisp disp="flex" alignItem="center" marginTop="8px">
                  {details.provider_photo ? (
                    <Image
                      loading="lazy"
                      src={details.provider_photo}
                      height="32px"
                      width="32px"
                      borderRadius="50%"
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        height: "32px",
                        width: "32px",
                        borderRadius: "50%",
                        background: "#F5F5F5",
                        color: "#565656",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "14px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                      }}
                    >
                      {details.provider_name?.charAt(0)}
                    </div>
                  )}
                  <div style={{ marginLeft: "10px" }}>
                    <AppointmentTitle>
                      {details.provider_name}{" "}
                      <span style={{ fontWeight: 400 }}>
                        , {details.specialty}
                      </span>
                    </AppointmentTitle>
                  </div>
                </Comdisp>

                <AppointmentSubText style={{ fontWeight: 500 }}>
                  {details.facility_name}
                </AppointmentSubText>

                <AppointmentAddressRow>
                  <AppointmentSubText>
                    {details.street}, {details.city}, {details.state}{" "}
                    {details.postal_code}
                  </AppointmentSubText>

                  <AppointmentActions>
                    {details.tele_health === "1" && details.accept !== "2" && (
                      <Button
                        background="none"
                        color="#2C7BE5"
                        fontWeight="500"
                        marginRight="16px"
                        onClick={() => window.open(details.start_url, "_blank")}
                      >
                        Join Telehealth
                      </Button>
                    )}

                    {details.accept !== "2" ? (
                      <Button
                        background="none"
                        color="#F97066"
                        fontWeight="500"
                        onClick={() => {
                          setApptcancel(true);
                          setCancelDate(
                            moment(details.ApptFromDate).format("Y-MM-DD"),
                          );
                          setCancelData(details);
                          dispatch(
                            changeAppointmentData({
                              name: "cancelID",
                              value: details.pc_eid,
                            }),
                          );
                        }}
                      >
                        Cancel Appointment
                      </Button>
                    ) : (
                      <AppointmentSubText style={{ color: "#F97066" }}>
                        Cancelled
                      </AppointmentSubText>
                    )}
                  </AppointmentActions>
                </AppointmentAddressRow>

                {index !== upcomingFiltered.length - 1 && (
                  <Hrline mt="6px" mb="8px" />
                )}
              </AppointmentWrapper>
            ))}
            {/* <PageSubTitle
                  clr="#407bff"
                  marginTop="20px"
                  fontweight="600"
                  lineHeight="33px"
                  marginBottom="14px"
                >
                  {details.pc_eventDate}
                </PageSubTitle>

                <Comdisp disp="flex" marginBottom="7px">
                  <FiClock className="clock" />
                  <Text
                    color="#7d8592"
                    fontWeight="500"
                    textAlign="left"
                    mt="0px"
                  >
                    {moment(details.ApptFromDate).format("hh:mm A")} -{" "}
                    {moment(details.ApptToDate).format("hh:mm A")} •{" "}
                    {details.duration}
                  </Text>
                </Comdisp>

                <Comdisp marginLeft="-2px" disp="flex" marginTop="6px">
                  <BiLocationPlus className="locate" />
                  <Text
                    color="#7D8592"
                    fontSize="14px"
                    fontWeight="600"
                    textAlign="left"
                    mt="0px"
                    mb="4px"
                  >
                    {details.facility_name}
                  </Text>
                </Comdisp>

                <Text
                  color="#7D8592"
                  marginLeft="30px"
                  fontSize="14px"
                  fontWeight="400"
                  textAlign="left"
                  mt="0px"
                  mb="6px"
                  height="43px"
                  width="96%"
                  className="scrollbar_adujust"
                >
                  {details.street}, {details.city}, {details.state},
                  {details.postal_code}
                </Text>

                <Comdisp
                  disp="flex"
                  alignItem="center"
                  JustifyContent="flex-start"
                >
                  <Image
                    loading="lazy"
                    src={Rectangle}
                    height="32px"
                    width="32px"
                    borderRadius="50%"
                  />
                  <Comdisp disp="column" marginTop="0px" textAlign="left">
                    <Text
                      color="#263446"
                      paddingLeft="8px"
                      fontSize="16px"
                      fontWeight="500"
                      textAlign="left"
                      mt="0px"
                      mb="0px"
                      title={details.provider_name} // <-- Tooltip
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "block",
                        width: "100%",
                      }}
                    >
                      {details.provider_name?.length > 30
                        ? details.provider_name.slice(0, 30) + "..."
                        : details.provider_name}
                    </Text>
                    <Text
                      paddingLeft="8px"
                      paddingTop="2px"
                      color="#7D8592"
                      fontSize="14px"
                      fontWeight="400"
                      textAlign="left"
                      mt="0px"
                      mb="0px"
                      title={details.provider_name} // <-- Tooltip
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "block",
                        width: "100%",
                      }}
                    >
                      {details.specialty}
                      {details.specialty?.length > 30
                        ? details.specialty.slice(0, 30) + "..."
                        : details.specialty}
                    </Text>
                  </Comdisp>
                </Comdisp>
                <Hrline />
                {details.tele_health === "1" && details.accept !== "2" && (
                  <Button
                    background="#407BFF"
                    color="#fff"
                    marginBottom="10px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    onClick={() => window.open(details.start_url, "_blank")}
                  >
                    Join Telehealth
                  </Button>
                )}
                {details.accept === "2" ? (
                  <Button
                    background="none"
                    display="flex"
                    marginLeft="auto"
                    marginRight="auto"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <AiOutlineCloseCircle fill="#F97066" fontSize="1.5em" />
                    <Text marginLeft="10px" color="#f97066" mt="0px" mb="0px">
                      Cancelled
                    </Text>
                  </Button>
                ) : (
                  <Button
                    background="none"
                    display="flex"
                    marginLeft="auto"
                    marginRight="auto"
                    alignItem="center"
                    JustifyContent="center"
                    onClick={() => {
                      setApptcancel(true);
                      setCancelDate(
                        moment(details.ApptFromDate).format("Y-MM-DD"),
                      );
                      setCancelData(details);

                      dispatch(
                        changeAppointmentData({
                          name: "cancelID",
                          value: details.pc_eid,
                        }),
                      );
                    }}
                  >
                    <AiOutlineCloseCircle fill="#F97066" font-size="1.5em" />
                    <Text marginLeft="10px" color="#f97066" mt="0px" mb="0px">
                      Cancel Booking
                    </Text>
                  </Button> */}
          </>
        ) : (
          //   ))}
          // </>
          <>
            {/* <PageSubTitle media>Upcoming Appointment</PageSubTitle> */}
            <NoDataImage
              image={NoAppt}
              height="260.75px"
              imageHeight="203.75px"
              imageWidth="271.45px"
              margin="22px 0px 0px 0px"
            />
            {/* <Hrline mt="12.5px" mb="21px" /> */}

            {/* <Button
              marginLeft="auto"
              marginRight="auto"
              background="none"
              display="flex"
              onClick={() => navigatePage()}
            >
              <Text
                fontSize="16px"
                clr="#407BFF"
                mt="0px"
                mb="0px"
                lineHeight="20px"
                color="#407BFF"
                fontWeight="500"
                letterSpacing="0.0025em"
                id="dbrd_sch-p_mkApt"
              >
                Make Appointment
              </Text>
            </Button> */}
          </>
        )}
      </Card>
      <AppointmentCancel
        show={apptCancel}
        CancelDate={CancelDate}
        CancelData={CancelData}
        HidePopup={() => setApptcancel(false)}
      />
    </>
  );
};

export default Nextappt;
